angular.module('tgaApp').config(['envServiceProvider', '$logProvider',
  function (envServiceProvider, $logProvider) {
    // set the domains and variables for each environment
    envServiceProvider.config({
      domains: {
        testing: ['trainingarcade.com', 'thegameagencyportal.com'],
        production: ['thetrainingarcade.com'],
        staging: ['staging.thetrainingarcade.com'],
      },
      vars: {
        testing: {
          forceDomain: false,
          debug: false,
          serverAddress: '//tga-cms-backend.trainingarcade.com/api/v5/',
          cachingServerAddress: 'https://thegameagencyportal.com:8081/',
          useCaching: false,
        },
        production: {
          forceDomain: false,
          debug: false,
          serverAddress: '//api.thetrainingarcade.com/api/v5/',
          cachingServerAddress: 'https://api.thetrainingarcade.com/cache/',
          useCaching: false,
        },
        staging: {
          forceDomain: false,
          debug: false,
          serverAddress: '//api.staging.thetrainingarcade.com/api/v5/',
          cachingServerAddress: 'https://api.staging.thetrainingarcade.com/cache/',
          useCaching: false,
        },
      },
    });

    // run the environment check, so the comprobation is made
    // before controllers and services are built
    envServiceProvider.check();

    // force set development toggle
    // envServiceProvider.set('development');

    // set debug logs off if in production
    $logProvider.debugEnabled(envServiceProvider.get() !== 'production');
  }]);
